export const setMiniCartTotalQuantity = (totalQuantity) => {
    document.querySelectorAll('.cart-counter').forEach((currentNode) => {
        currentNode.innerHTML = totalQuantity;
        currentNode.classList.toggle('d-none', totalQuantity === 0);
    });

    if (document.querySelector('.product-detail-modal-cart-counter'))
        document.querySelector('.product-detail-modal-cart-counter').innerHTML = totalQuantity;
}